import { render, staticRenderFns } from "./modalList.vue?vue&type=template&id=87f65cf2&scoped=true&"
import script from "./modalList.vue?vue&type=script&lang=js&"
export * from "./modalList.vue?vue&type=script&lang=js&"
import style0 from "./modalList.vue?vue&type=style&index=0&id=87f65cf2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87f65cf2",
  null
  
)

export default component.exports